import { vmResourceDistributionGraphDto } from '../dto/vmResourceDistributionGraphDto';
import { HorizontalGaugeBarSeries } from '@liveoptics/react-ui/dist/types/interfaces/Charts';

const legendItems = [
    { color: '#4694CE', label: 'Standard' },
    { color: '#27C595', label: 'Unique' },
];

export class vmResourceDistributionGraphTransformer {
    public static from(response: vmResourceDistributionGraphDto): HorizontalGaugeBarSeries[] {
        var data = response.Data;
        const series: HorizontalGaugeBarSeries[] = [];

        var dataPoint: HorizontalGaugeBarSeries = { title: 'VMs', values: [{ key: legendItems[1].label, color: legendItems[1].color, value: data.VMs.Unique }, { key: legendItems[0].label, color: legendItems[0].color, value: data.VMs.Standard }] };
        series.push(dataPoint);
        dataPoint = { title: '# vCPUs', values: [{ key: legendItems[1].label, color: legendItems[1].color, value: data.NumberVCPUs.Unique }, { key: legendItems[0].label, color: legendItems[0].color, value: data.NumberVCPUs.Standard }] };
        series.push(dataPoint);
        dataPoint = { title: 'Memory (GiB)', values: [{ key: legendItems[1].label, color: legendItems[1].color, value: data.ProvisionedMemoryGB.Unique }, { key: legendItems[0].label, color: legendItems[0].color, value: data.ProvisionedMemoryGB.Standard }] };
        series.push(dataPoint);
        dataPoint = { title: 'Used Storage (TiB)', values: [{ key: legendItems[1].label, color: legendItems[1].color, value: data.UsedStorageTB.Unique }, { key: legendItems[0].label, color: legendItems[0].color, value: data.UsedStorageTB.Standard }] };
        series.push(dataPoint);
        dataPoint = { title: 'Allocated Storage (TiB)', values: [{ key: legendItems[1].label, color: legendItems[1].color, value: data.AllocatedStorageTB.Unique }, { key: legendItems[0].label, color: legendItems[0].color, value: data.AllocatedStorageTB.Standard }] };
        series.push(dataPoint);

        return series;
    }
}
